import { getReqMessage, getSelectMessage } from '../../utils/formValidation/errorMessageFunctions';

export const validate = (newEntry) => {
    let newErrors = {};

    if (newEntry.closeParticipantOnClaimPaid && !newEntry.participantClosureStatusReasonId) {
        newErrors = {
            ...newErrors,
            participantClosureStatusReasonId: {
                error: true,
                message: getSelectMessage('closure participant status reason')
            }
        };
    }

    if (!newEntry.claimTypeStatuses.some((el) => el.startingStatus)) {
        newErrors = {
            ...newErrors,
            hasStartStatus: {
                error: true,
                message: getReqMessage('A starting status')
            }
        };
    }
    return newErrors;
};
